import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import logo from "../assets/admin_logo.png";
import signature from "../assets/signature.png";
import stamp from "../assets/company_stamp.png";

const PRIMARY_COLOR = [206, 37, 122];

export const generateInvoicePDF = (report, yearMonth) => {
  const doc = new jsPDF("p", "mm", "a4");

  /* ==============================
     HEADER
  ============================== */
  doc.addImage(logo, "PNG", 14, 10, 22, 22);

  doc.setFontSize(16);
  doc.setTextColor(...PRIMARY_COLOR);
  doc.text("Mogzit In Home Care", 42, 18);

  doc.setFontSize(10);
  doc.setTextColor(80);
  doc.text("Motherly Care Right Here", 42, 26);

  doc.setFontSize(11);
  doc.setTextColor(...PRIMARY_COLOR);
  doc.text("Wage Payment Revenue Report", 14, 42);

  doc.setTextColor(0);

  /* ==============================
     SUMMARY TABLE
  ============================== */
  autoTable(doc, {
    startY: 48,
    head: [["Type", "Amount (ETB)"]],
    body: [
      ["Platform Fees (20%)", (report.invoiceTotal || 0).toLocaleString()],
      [
        "Disbursed to Caregivers (80%)",
        (report.subscriptionTotal || 0).toLocaleString(),
      ],
      ["GRAND TOTAL", (report.grandTotal || 0).toLocaleString()],
    ],
    styles: {
      fontSize: 10,
      cellPadding: 5,
    },
    columnStyles: {
      0: { halign: "left" },
      1: { halign: "right" },
    },
    headStyles: {
      fillColor: PRIMARY_COLOR,
      textColor: 255,
      fontStyle: "bold",
    },
    alternateRowStyles: {
      fillColor: [245, 245, 245],
    },
    didParseCell: function (data) {
      if (data.section === "head") {
        if (data.column.index === 0) {
          data.cell.styles.halign = "left";
        }
        if (data.column.index === 1) {
          data.cell.styles.halign = "right";
        }
      }
    },
  });

  /* ==============================
     MONTHLY SUMMARY
  ============================== */
  const monthlySummaryEntries = report.monthlySummary
    ? Object.entries(report.monthlySummary)
    : [];

  if (monthlySummaryEntries.length > 0) {
    autoTable(doc, {
      startY: doc.lastAutoTable.finalY + 12,
      head: [["Month", "Total (ETB)"]],
      body: monthlySummaryEntries.map(([m, v]) => [
        m,
        (v || 0).toLocaleString(),
      ]),
      styles: {
        fontSize: 10,
        cellPadding: 5,
      },
      columnStyles: {
        0: { halign: "left" },
        1: { halign: "right" },
      },
      headStyles: {
        fillColor: PRIMARY_COLOR,
        textColor: 255,
        fontStyle: "bold",
      },
      alternateRowStyles: {
        fillColor: [248, 248, 248],
      },
      didParseCell: function (data) {
        if (data.section === "head") {
          if (data.column.index === 0) {
            data.cell.styles.halign = "left";
          }
          if (data.column.index === 1) {
            data.cell.styles.halign = "right";
          }
        }
      },
    });
  }

  /* ==============================
     SIGNATURE & STAMP
  ============================== */
  const signY = doc.lastAutoTable.finalY + 22;

  doc.setFontSize(10);
  doc.text("Authorized Signature", 14, signY);

  doc.addImage(signature, "PNG", 14, signY + 4, 40, 18);
  doc.addImage(stamp, "PNG", 70, signY - 2, 40, 40);

  /* ==============================
     FOOTER
  ============================== */
  doc.setFontSize(8);
  doc.setTextColor(90);
  doc.text(
    [
      report.company?.name || "Mogzit In Home Care",
      report.company?.address || "Addis Ababa, Ethiopia",
      report.company?.phones || "+251-XXX-XXXX",
      report.company?.email || "info@mogzit.com",
    ],
    105,
    270,
    {
      align: "center",
      maxWidth: 180,
    },
  );

  doc.save(`wage-payment-report-${yearMonth}.pdf`);
};
